import {
  ADD_TEXT,
  SAVE_TEXT_PROPERTIES,
  LOAD_TEXTS_BY_BOOK_ID,
  TOGGLE_TEXT_ACTIVE,
  CHANGE_TEXT_PROPERTY,
  DELETE_TEXT,
} from '../../action-types/entities/texts';

import { deleteTextFromPage } from '../../actions/entities/pages';

export const addText = textProperties => ({
  type: ADD_TEXT,
  textProperties,
});

export const saveTextProperties = (id, properties) => ({
  type: SAVE_TEXT_PROPERTIES,
  id,
  properties,
});

export const loadTextsByBookId = texts => ({
  type: LOAD_TEXTS_BY_BOOK_ID,
  texts,
});

export const toggleIsActive = textId => ({
  type: TOGGLE_TEXT_ACTIVE,
  textId,
});

export const changeTextProperty = (textId, property, value) => ({
  type: CHANGE_TEXT_PROPERTY,
  textId,
  property,
  value,
});

export const deleteTextFromTexts = textId => ({
  type: DELETE_TEXT,
  textId,
});

export const deleteText = textId => (dispatch) => {
  dispatch(deleteTextFromPage(textId));
  dispatch(deleteTextFromTexts(textId));
};




// WEBPACK FOOTER //
// ./src/redux/actions/entities/texts.js